import Image from 'next/image';

import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './HeroBanner.styles';

export function HeroBanner() {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <picture className={slots.picture()}>
        <source
          srcSet={staticMediaUrl(
            'landing/bioderma_galchonok/hero-banner-bg_sm.jpg'
          )}
          media="(max-width: 767px)"
        />
        <img
          className={slots.bg()}
          src={staticMediaUrl('landing/bioderma_galchonok/hero-banner-bg2.jpg')}
          alt="Bioderma Galchonok"
          width={1920}
          height={1080}
        />
      </picture>
      <div className={slots.content()}>
        <div className={slots.productsImageWrapper()}>
          <picture>
            <source
              srcSet={staticMediaUrl(
                'landing/bioderma_galchonok/hero-banner-products2_sm2.png'
              )}
              media="(max-width: 767px)"
            />
            <img
              className={slots.productsImage()}
              src={staticMediaUrl(
                'landing/bioderma_galchonok/hero-banner-products2.png'
              )}
              alt="Bioderma Galchonok"
              width={1920}
              height={1080}
            />
          </picture>
        </div>
        <div className={slots.logoBlockWrapper()}>
          <div className={slots.logoBlock()}>
            <Image
              className={slots.logoBlockImage()}
              src={staticMediaUrl(
                'landing/bioderma_galchonok/logo-galchonok.png'
              )}
              alt="Bioderma Galchonok"
              width={349}
              height={282}
            />
            <div
              className={slots.logoBlockDivider()}
              aria-hidden
            />
            <p className={slots.logoBlockText()}>
              ПОМОГАТЬ
              <br /> ПРОСТО
            </p>
          </div>
          <p className={slots.title()}>
            <span className={slots.bioderma()}>Sensibio</span>{' '}
            <span className={slots.divider()}>х</span>{' '}
            <span className={slots.sensibio()}>галчонок</span>
          </p>
          <p className={slots.description()}>
            БЕРЕЖНЫЙ УХОД И ПОМОЩЬ
            <br /> ДЕТЯМ И МОЛОДЕЖИ С ЦП<sup className={slots.sup()}>1</sup>
          </p>
        </div>
      </div>
    </div>
  );
}
